import fs from 'node:fs'
import path from 'node:path'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'
import { CONFIG_IMPORT_PATTERN } from '@cli-constants/patterns.js'
import { CONFIG_IMPORT_SHIM } from '@cli-constants/scaffolding.js'

export function guardBetterstartConfig(cwd: string, restores: Array<() => void>): void {
  const configPath = path.join(cwd, CONFIG_FILE_NAME)
  if (!fs.existsSync(configPath)) return

  const original = fs.readFileSync(configPath, 'utf-8')
  if (!CONFIG_IMPORT_PATTERN.test(original)) return

  fs.writeFileSync(configPath, original.replace(CONFIG_IMPORT_PATTERN, CONFIG_IMPORT_SHIM), 'utf-8')
  restores.push(() => fs.writeFileSync(configPath, original, 'utf-8'))
}
